import { render, staticRenderFns } from "./EmployeeBranchCreateOrUpdate.vue?vue&type=template&id=33ec81e6&"
import script from "./EmployeeBranchCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports